import { useState } from 'react'
import { useLocation } from 'react-router-dom'

import { SplitViewContext, SplitViewType } from './SplitViewContext'

interface Props {
  children: React.ReactNode
}

const SplitViewContextProvider: React.FC<Props> = ({ children }) => {
  const [activeSplitView, setActiveSplitView] = useState<SplitViewType>(null)
  const [eInvoicePreviewUrl, setEInvoicePreviewUrl] = useState('')
  const [eInvoicePreviewFileName, setEInvoicePreviewFileName] = useState('')
  const location = useLocation()

  // Close all split views when navigating away from e-invoices detail page
  const isEInvoiceDetailPage =
    location.pathname.startsWith('/e-invoices/') &&
    !location.pathname.endsWith('/e-invoices/history')
  if (activeSplitView === 'eInvoicePreview' && !isEInvoiceDetailPage) {
    setActiveSplitView(null)
    setEInvoicePreviewUrl('')
  }

  const closeAllSplitViews = () => {
    setActiveSplitView(null)
    setEInvoicePreviewUrl('')
    setEInvoicePreviewFileName('')
  }

  // Override setActiveSplitView to manage mutual exclusivity
  const managedSetActiveSplitView = (view: SplitViewType) => {
    setActiveSplitView(view)
  }

  const contextValue = {
    activeSplitView,
    setActiveSplitView: managedSetActiveSplitView,
    eInvoicePreviewUrl,
    setEInvoicePreviewUrl,
    eInvoicePreviewFileName,
    setEInvoicePreviewFileName,
    closeAllSplitViews,
  }

  return (
    <SplitViewContext.Provider value={contextValue}>
      <>{children}</>
    </SplitViewContext.Provider>
  )
}

export default SplitViewContextProvider
